export enum EndpointType {
  CONFIGURATION = 'configuration',
  UI = 'ui',
  API = 'api',
  OTHER = 'other',
  ACCESS = 'access'
}
